import { resetPassword as resetPasswordApi } from '@/features/auth/internal/api/actions/reset-password';
import { pagesRoutes } from '@/shared/constants/routes';
import {
  AuthUnexpectedError,
  ResetPasswordSocialOnlyError,
} from '@/features/auth/shared/api/errors/client-auth-errors';
import { RESET_PASSWORD_ERRORS } from '@/shared/types/errors/reset-password-errors';

export const resetPassword = async (email: string): Promise<void> => {
  const path = pagesRoutes.changePassword.href;

  try {
    const response = await resetPasswordApi(email, path);
    if (response && response.errors.length > 0) {
      const hasSocialOnlyError = response.errors.some(
        (error) => error.message === RESET_PASSWORD_ERRORS.SOCIAL_ONLY,
      );
      if (hasSocialOnlyError) {
        throw new ResetPasswordSocialOnlyError();
      }
      throw new AuthUnexpectedError();
    }
  } catch (e: unknown) {
    if (e instanceof ResetPasswordSocialOnlyError || e instanceof AuthUnexpectedError) {
      throw e;
    }
    throw new AuthUnexpectedError();
  }
};
